import initHeader from './layout/header';
import initCommercePreview from './components/commerce';
import initHomeHero from './components/home-hero';
import initProductDetail from './components/product-detail';
import initProductCategory from './components/product-category';
import initProductSearch from './components/product-search';
import initSocialLinks from './components/social-links';

document.addEventListener('DOMContentLoaded', function () {
  initHeader();
  initCommercePreview();
  initHomeHero();
  initProductDetail();
  initProductCategory();
  initProductSearch();
  initSocialLinks();
});
